
import React from 'react';
import { useSettings } from '@/context/SettingsContext';
import RpgCharacterSheet from './RpgCharacterSheet';

const CharacterSheet: React.FC = () => {
  const { enableRpgMode } = useSettings();

  // Only show character sheet when RPG mode is enabled
  if (!enableRpgMode) {
    return null;
  }

  return <RpgCharacterSheet />;
};

export default CharacterSheet;
